// @flow
import 'react-datepicker/dist/react-datepicker.css';
import React from 'react';
import { Form, FormikProps, Formik, FormikHelpers, FormikValues } from 'formik';
import * as Yup from 'yup';
import cogoToast from 'cogo-toast';
import ReCAPTCHA from 'react-google-recaptcha';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import api from 'apiClient/api';
import { StringUtil } from 'utils/StringUtil';
import { DateUtil } from 'utils/DateUtil';
import { CURRENT_COUNTRY_CODE } from 'config/env';
import { FormButton } from 'components/molecules/formButton';
import { FormDropdown } from 'components/molecules/formDropdown';
import { FormInput } from 'components/molecules/formInput';
import { FormTextArea } from 'components/molecules/formTextArea';
import { people_count } from 'Mock/reservationFormPeopleCount';
import DateIcon from 'assets/images/Reservations-date.png';
import TimeIcon from 'assets/images/Reservations-time.png';
// eslint-disable-next-line
import styles from "./styles.scss";

const API_ENDPOINT = 'createTableReservationForRestaurantOutlet.json';

type Props = {
  isMobile: boolean,
  contactEmail?: string,
};

type FormState = {
  customer_mobile: string,
  customer_email?: string,
  customer_name?: string,
  pax_count: number,
  comments?: string,
};

type State = {
  data: FormState,
};

const initialState: State = {
  data: {
    customer_mobile: '',
    customer_email: '',
    customer_name: '',
    pax_count: 1,
    comments: '',
  },
};

export class ReservationForm extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      ...this.getInitialState(),
      date_value: new Date(),
      time_value: this.setInitialTiming(),
      initial_time_value: this.setInitialTiming(),
      checkForExcludedTime: true,
      isDisabled: true,
      isSubmitted: false,
    };
  }

  getInitialState = () => {
    return {
      data: { ...initialState.data },
    };
  };

  onTimeChange = time => {
    this.setState({ time_value: time });
  };

  onDateChange = date => {
    this.setState({ date_value: date });
    if (date > new Date()) this.setState({ checkForExcludedTime: false });
    else this.setState({ checkForExcludedTime: true });
  };

  getOpeningClosingTimings = () => {
    let morningTimings = DateUtil.DatesCollectionBasedOnTimeRange(
      this.props.morningOpeningTime,
      this.props.morningClosingTime
    );
    let eveningTimings = DateUtil.DatesCollectionBasedOnTimeRange(
      this.props.eveningOpeningTime,
      this.props.eveningClosingTime
    );
    return morningTimings.concat(eveningTimings);
  };

  onCaptchaChange = () => {
    this.setState({ isDisabled: false });
  };

  addMobileSpacing = () => {
    return (
      <>
        <br />
        <br />
        <br />
      </>
    );
  };

  setInitialTiming = () => {
    let local_time = new Date();
    local_time.setMinutes(local_time.getMinutes() + 30);
    //increases the current time by 30 minutes as per client-request.
    local_time = DateUtil.roundCurrentTime(local_time);
    return local_time;
  };

  compareSelectedTime = time => {
    const selectedDate = new Date(time);
    return this.state.initial_time_value <= selectedDate;
  };

  render = () => {
    const recaptchaRef = React.createRef();
    const { isMobile } = this.props;
    const buttonMode = isMobile ? 'transparent' : 'light';

    const DatePickerButton = ({ value, onClick }) => {
      return (
        <div className={'calendar-action-button'} onClick={onClick}>
          <div className={'icon-container'}>
            <img src={DateIcon} alt={'date'} />
          </div>
          <h4>{value}</h4>
        </div>
      );
    };

    const TimePickerButton = ({ value, onClick }) => {
      return (
        <div className={'time-action-button'} onClick={onClick}>
          <div className={'icon-container'}>
            <img src={TimeIcon} alt={'time'} />
          </div>
          <h4>{value}</h4>
        </div>
      );
    };

    return (
      <div className={'form-container'}>
        <Formik
          initialValues={this.state.data}
          onSubmit={this.onSubmit}
          validationSchema={this.getSchema()}
        >
          {(props: FormikProps<State>) => (
            <Form>
              <FormInput
                name={'customer_mobile'}
                label={'10 DIGIT MOBILE NUMBER'}
                placeholder={'10 DIGIT MOBILE NUMBER'}
                value={props.values['customer_mobile']}
                type={'number'}
              />
              <FormInput
                name={'customer_email'}
                label={'EMAIL ADDRESS'}
                placeholder={'Email Address'}
                type={'email'}
                value={props.values['customer_email']}
              />
              <FormInput
                name={'customer_name'}
                label={'Guest Name'}
                placeholder={'GUEST NAME'}
                type={'text'}
                value={props.values['customer_name']}
              />
              <div className={'people-count-container'}>
                <FormInput
                  name={'number_of_guests_label'}
                  label={'Number Of Guests'}
                  placeholder={'Number Of Guests'}
                  type={'text'}
                  disabled={true}
                />
                <FormDropdown
                  name={'pax_count'}
                  placeholder={'1 PEOPLE'}
                  options={people_count}
                  value={props.values['pax_count']}
                  showPlaceholder={true}
                />
              </div>
              <div className={'schedule-picker'}>
                <div className={'date-container'}>
                  <DatePicker
                    dateFormat={'dd/MM/yyyy'}
                    selected={this.state.date_value}
                    onChange={date => this.onDateChange(date)}
                    customInput={<DatePickerButton />}
                    popperPlacement={'bottom-end'}
                    minDate={new Date()}
                  />
                </div>
                <div className={'time-container'}>
                  <DatePicker
                    selected={this.state.time_value}
                    onChange={time => this.onTimeChange(time)}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={30}
                    timeCaption={'Time'}
                    timeFormat={'p'}
                    dateFormat={'h:mm aa'}
                    customInput={<TimePickerButton />}
                    popperPlacement={'bottom'}
                    includeTimes={this.getOpeningClosingTimings()}
                    filterTime={
                      this.state.checkForExcludedTime
                        ? time => this.compareSelectedTime(time)
                        : null
                    }
                  />
                </div>
              </div>
              <FormTextArea
                name={'comments'}
                label={'Comments'}
                placeholder={'Comments'}
                value={props.values['comments']}
              />
              <div className={'captcha'}>
                {this.state.isSubmitted && this.state.isDisabled && (
                  <h4 className={'captcha-warn'}>Please complete captcha</h4>
                )}
                <ReCAPTCHA
                  ref={recaptchaRef}
                  name={'captcha_check'}
                  sitekey={'6Le0t_wZAAAAAJgbC-GR2v03NujjhBNnG2ZOzZCG'}
                  onChange={this.onCaptchaChange}
                  onExpired={() => this.setState({ isDisabled: true })}
                  onErrored={() => this.setState({ isDisabled: true })}
                />
              </div>
              <FormButton
                mode={buttonMode}
                disabled={props.isSubmitting}
                onClick={() => this.setState({ isSubmitted: true })}
              />
            </Form>
          )}
        </Formik>
        {this.props.isMobile && this.addMobileSpacing()}
      </div>
    );
  };

  // TODO: Common component for toast?
  onSubmit = (values: FormikValues, actions: FormikHelpers<FormikValues>) => {
    const country_code = CURRENT_COUNTRY_CODE.replace('+', '');
    values['customer_mobile'] =
      this.state.isSubmitted && !this.state.isDisabled
        ? `${country_code}${values['customer_mobile']}`
        : values['customer_mobile'];
    const trimmedValues = this.trimValues(values);
    const errors = this.getErrors(trimmedValues);
    const date = DateUtil.getFullDateString(this.state.date_value);
    const time = this.state.time_value.toLocaleTimeString();
    const dateTime = date + ' ' + time;
    let formattedTime = moment(dateTime).toISOString();
    formattedTime = formattedTime.slice(0, 19) + 'Z';
    if (errors.length > 0) {
      // TODO: show errors
      alert(errors);
      return;
    }

    actions.setSubmitting(!this.state.isDisabled);
    const { hide: hideLoader } =
      !this.state.isDisabled &&
      cogoToast.loading('Submitting your information...', {
        hideAfter: 0,
      });

    const payload = { ...trimmedValues };
    payload.resrv_datetime = formattedTime;
    payload.outlet_id = this.props.outletId;

    this.state.isSubmitted &&
      !this.state.isDisabled &&
      api
        .post(API_ENDPOINT, payload)
        .then(res => {
          if (res.data.status === 'success') {
            hideLoader();
            if (res.data.data.status) {
              setTimeout(() => {
                cogoToast.success('Submitted your information successfully!');
              }, 1000);
            } else {
              setTimeout(() => {
                cogoToast.error(res.data.data.error[0]);
              }, 1000);
            }
            actions.resetForm({ ...this.getInitialState() });
          } else {
            hideLoader();
            setTimeout(() => {
              cogoToast.error(res.data.message);
            }, 1000);
          }
        })
        .catch(error => {
          hideLoader();
          setTimeout(() => {
            cogoToast.error('Failed to submit your information');
          }, 1000);
        })
        .finally(() => {
          this.setState({ isSubmitted: false });
          actions.setSubmitting(false);
        });
  };

  trimValues = (values: FormState): FormState => {
    return Object.keys(values).reduce((trimmed, key) => {
      if (!trimmed[key]) {
        delete trimmed.country;
        trimmed[key] = values[key].toString().trim();
      }

      return trimmed;
    }, {});
  };

  getValidation = () => {
    return Yup.string()
      .trim()
      .required('Please select number of guests');
  };

  getErrors = (
    values: FormState
  ): Array<{ field: string, message: string }> => {
    const errors = [];

    // For sales force api  Only mobile number is mandatory
    if (!values['customer_mobile'] || values['customer_mobile'] === '') {
      errors.push({
        field: 'customer_mobile',
        message: 'Please enter your Phone number',
      });
    }

    return errors;
  };

  getSchema = () => {
    const schema = {
      customer_mobile: Yup.string()
        .trim()
        .required(
          this.props.isMobile
            ? 'Enter phone number'
            : 'Please enter your phone number'
        )
        .matches(
          StringUtil.regexPatterns.phoneINDUS,
          'Please enter a valid phone number'
        ),
      customer_email: Yup.string()
        .trim()
        .required(this.props.isMobile ? 'Enter email' : 'Please enter email'),
      customer_name: Yup.string()
        .trim()
        .required(
          this.props.isMobile ? 'Enter guest name' : 'Please enter guest name'
        ),
      pax_count: this.state.isSubmitted
        ? this.getValidation()
        : Yup.string().trim(),
      comments: Yup.string().trim(),
    };
    return Yup.object().shape(schema, [['customer_mobile', 'pax_count']]);
  };
}
